export const TEST_USER_ID = 1;
export const TEST_EXAM_CODE = '1234';
export const TEST_REDIRECT_URL = 'https://missionmed.com.au/';
export const API_URL = process.env.REACT_APP_API_URL;
